module.exports = __webpack_public_path__ + "static/002-197d3a3997f763ded38024251426ea9c.jpg";